import { render, staticRenderFns } from "./FooterRegretSection.vue?vue&type=template&id=edc02924&scoped=true"
import script from "./FooterRegretSection.vue?vue&type=script&lang=js"
export * from "./FooterRegretSection.vue?vue&type=script&lang=js"
import style0 from "./FooterRegretSection.vue?vue&type=style&index=0&id=edc02924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc02924",
  null
  
)

export default component.exports